<style scoped>

</style>

<template>
  <mu-checkbox v-model="modelAdmin"></mu-checkbox>
</template>

<script>
// Library
import axios from "axios";

export default {
  name: 'ManagerCheckbox',
  props: {
    channelId: {
      type: String,
      required: true
    },
    user: {
      type: Object,
      required: true
    },
    isAdmin: {
      type: Boolean,
      required: true
    },
  },
  data() {
    return {
      // Model
      modelAdmin: this.isAdmin,
    }
  },
  computed: {

  },
  watch: {
    modelAdmin(newValue) {
      this.onActionUpdate(newValue);
    },
  },
  methods: {
    // Event
    onActionUpdate(newValue) {
      if(newValue) {
        axios.put(this.$store.getters.urlApi + "admin/channel/" + this.channelId, {
          'user_id': this.user._id
          }, {
          headers: {
            token: this.$store.state.auth.token,
            'content-type': 'application/json'
          },
          }
        ).then(() => {
          this.$toast.success(this.$t('toast.edit'));
        });
      } else {
        axios.delete(this.$store.getters.urlApi + "admin/channel/" + this.channelId, {
          headers: {
            token: this.$store.state.auth.token
          },
          params: {
            'user_id': this.user._id
          }
          }
        ).then(() => {
          this.$toast.success(this.$t('toast.edit'));
        });
      }
    }
  },
}
</script>
